import React, { Component } from "react"
import {BrowserRouter, Route, Routes } from "react-router-dom"
import Landing_page from "./component/Landing";
import Signup from "./component/Signup/signup";
import Login from "./component/Signup/login";
import ForgottenPassword from "./component/Signup/forgotten.password";
import AdminSignup from "./component/Signup/admin.signup";
import AdminLogin from "./component/Signup/admin.login";
// import PasswordReset from "./component/Signup/password.reset";
import TutorDashboard from "./component/tutor/totur.dashboard";
import TutorPrerecordedCourse from "./component/tutor/online_prerecorded";
import TutorLiveCourse from "./component/tutor/online_live";
import TutorGroupPhysicalCourse from "./component/tutor/group_physical";
import TutorPrivatePhysicalCourse from "./component/tutor/private_physical";
import TutorCourseDescription from "./component/tutor/description";
import Dashboard from "./component/user/dashboard";
import PrerecordedCourse from "./component/user/online_prerecorded";
import LiveCourse from "./component/user/online_live";
import GroupPhysicalCourse from "./component/user/group_physical";
import PrivatePhysicalCourse from "./component/user/private_physical";
import CourseDescription from "./component/user/description";
import Profile from "./component/user/profile";
import TutorProfile from "./component/tutor/profile";
import Library from "./component/user/Library";
import UserSearchParams from "./component/user/search.params";
import TutorSearchParams from "./component/tutor/search.params";
import UidPasswordReset from "./component/Signup/password.uid.reset";
import SearchParams from "./component/search_params";
import LandingCourseDescription from "./component/description";
import LandCourse from "./component/course";
import PaymentVerify from "./part/PaymentVerify";
import DescriptPayment from "./component/user/descript.payment";
import TutorLibrary from "./component/tutor/Library";
import TutorDescriptPayment from "./component/tutor/descript.payment";
import ScrollToTop from "./part/scrolltotop";
import Dashcontact from "./component/user/contact";
import TutorDashcontact from "./component/tutor/contact";
import LandingContact from "./component/contact";
import Page404 from "./component/404";
import TutorCertificate from "./component/tutor/certificate";
import TutorExamQuestion from "./component/tutor/exam.question";
import ExamQuestion from "./component/user/exam_question";
import StudentList from "./component/tutor/studentList";
import Blog from "./component/blog";
// import SingleBlog from "./component/single_blog";
import BlogEdit from "./component/blog_edit";
import SingleMainBlog from "./component/single_main_blog";
import SelectedCourse from "./component/user/selectedCourse";
import TutorCourseEdit from "./component/tutor/course_edit";
import TutorCourses from "./component/tutor/courses";
import TutorStudents from "./component/tutor/student";
import SelectedCourseEdit from "./component/tutor/selected_course_edit";
import TutorInterestedStudents from "./component/tutor/interested_student";
import TutorBlog from "./component/tutor/blog";
import TutorBlogEdit from "./component/tutor/blogedit";
import ExamScore from "./component/user/exam_Score";
import ExamScoreCover from "./component/user/exam_score_cover";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
      <div className="App">
      <ScrollToTop>

       <Routes>
       
        <Route exact path="/" Component={Landing_page} />
        <Route exact path="/Landing_description/:course_id/:course_name" Component={LandingCourseDescription} />
        <Route exact path="/landing_course" Component={LandCourse} />
        <Route exact path="/sign_up" Component={Signup} />
        <Route exact path="/login" Component={Login} />
        <Route exact path="/Admin_sign_up" Component={AdminSignup} />
        <Route exact path="/Admin_login" Component={AdminLogin} />
        <Route exact path="/forgotten_password" Component={ForgottenPassword} />
        <Route exact path="/password_reset/:Uid/:token" Component={UidPasswordReset} />
        <Route exact path="/dashboard" Component={Dashboard} />
        <Route exact path="/online_prerecorded" Component={PrerecordedCourse} />
        <Route exact path="/online_Live" Component={LiveCourse} />
        <Route exact path="/group_physical" Component={GroupPhysicalCourse} />
        <Route exact path="/private_physical" Component={PrivatePhysicalCourse} />
        <Route exact path="/description/:course_id/paymentverify" Component={DescriptPayment} />
        <Route exact path="/tutor_description/:course_id/paymentverify" Component={TutorDescriptPayment} />
        <Route exact path="/paymentverify/:course_id/:paystack_token" Component={PaymentVerify} />
        <Route exact path="/description/:course_id/:course_name" Component={CourseDescription} />

        <Route exact path="/course/unfound/:id" Component={SelectedCourse} />

        <Route exact path="/tutor_dashboard" Component={TutorDashboard} />
        <Route exact path="/tutor_online_prerecorded" Component={TutorPrerecordedCourse} />
        <Route exact path="/tutor_online_Live" Component={TutorLiveCourse} />
        <Route exact path="/tutor_group_physical" Component={TutorGroupPhysicalCourse} />
        <Route exact path="/tutor_private_physical" Component={TutorPrivatePhysicalCourse} />
        <Route exact path="/tutor_description/:course_id" Component={TutorCourseDescription} />

        <Route exact path="/tutor_courses" Component={TutorCourses} />
        <Route exact path="/tutor_students" Component={TutorStudents} />
        <Route exact path="/tutor_Interested_students" Component={TutorInterestedStudents} />
        <Route exact path="/tutor_blog" Component={TutorBlog} />
        <Route exact path="/tutor_blog_edit" Component={TutorBlogEdit} />

        <Route exact path="/tutor_course_edit" Component={TutorCourseEdit} />
        <Route exact path="/tutor_course_edit/:id" Component={SelectedCourseEdit} />


        <Route exact path="/profile" Component={Profile} />
        <Route exact path="/tutor_profile" Component={TutorProfile} />
        <Route exact path="/library" Component={Library} />
        <Route exact path="/tutor_library" Component={TutorLibrary} />
        <Route exact path="/dash_user_search/:prompt" Component={UserSearchParams} />
        <Route exact path="/dash_tutor_search/:prompt" Component={TutorSearchParams} />
        <Route exact path="/search/:prompt" Component={SearchParams} />
        <Route exact path="/dash_contact" Component={Dashcontact}/>
        <Route exact path="/tutor_dash_contact" Component={TutorDashcontact}/>
        <Route exact path="/contact" Component={LandingContact}/>
        <Route path="*" element={<Page404/>} />
        <Route exact path="/tutor_certificate" Component={TutorCertificate} />
        <Route exact path="/tutor_exam_question/:course_id" Component={TutorExamQuestion} />
        <Route exact path="/exam_question/:course_id" Component={ExamQuestion} />
        <Route exact path="/studentProfile/:student_id/:student_name" Component={StudentList} />


        <Route exact path="/exam-score/:id/:course_name/:courseid" Component={ExamScoreCover} />


        <Route exact path="/blog" Component={Blog} />
        <Route exact path="/blog/:id" Component={SingleMainBlog} />
        <Route exact path="/blog_edit" Component={BlogEdit} />
        
       </Routes>
       </ScrollToTop>
      </div> 
      </BrowserRouter>
    )
  }
}

export default App;
